import { render, staticRenderFns } from "./PostPdfImmoPromoteur.vue?vue&type=template&id=565580c8&"
import script from "./PostPdfImmoPromoteur.vue?vue&type=script&lang=js&"
export * from "./PostPdfImmoPromoteur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports